export const getRegionalWWDates = `query getRegionalWWDates($filter: RegionalWWDatesRequest!) {
    getRegionalWWDates(filter: $filter) {
      wWStartDate
      wWEndDate
    }
  }`
